import {
  CTA_BUTTON_ON_ALL_CSW,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import type { Experiment } from 'types/shopConfig'

export const showBuyButtonForAllCSWExperiment = (
  experiments: Experiment[],
  notIsSellerCrosssell: boolean
): boolean => {
  const ctaButtonOnAllCSW = getExperiment(CTA_BUTTON_ON_ALL_CSW, experiments)

  return (
    ctaButtonOnAllCSW.isEnabled &&
    ctaButtonOnAllCSW.variant === EXPERIMENT_VARIATION.V1 &&
    notIsSellerCrosssell
  )
}
